var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52673 8.55639C2.68416 8.55639 1.92455 8.04885 1.60206 7.27044C1.27957 6.49203 1.4577 5.59601 2.05339 5.00013L2.93756 4.11596L3.52673 4.70513L2.64298 5.58888C2.32717 5.90469 2.20383 6.36499 2.31942 6.79639C2.43502 7.22779 2.77198 7.56476 3.20338 7.68035C3.63478 7.79594 4.09508 7.67261 4.41089 7.3568L5.29464 6.47305L5.88381 7.06263L5.00006 7.94638C4.61009 8.33827 4.07958 8.55791 3.52673 8.55639ZM3.82131 6.76763L3.23214 6.17846L6.17839 3.23221L6.76756 3.82138L3.82173 6.76721L3.82131 6.76763ZM7.06256 5.88388L6.47298 5.29471L7.35673 4.41096C7.67684 4.0961 7.80348 3.63374 7.68849 3.19971C7.57351 2.76567 7.23457 2.42665 6.80056 2.31157C6.36655 2.19648 5.90416 2.32301 5.58923 2.64305L4.70506 3.5268L4.11589 2.93763L5.00006 2.05346C5.81468 1.24595 7.1288 1.24883 7.93987 2.0599C8.75095 2.87098 8.75382 4.1851 7.94631 4.99971L7.06256 5.88346V5.88388Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLinkIcon);
export default __webpack_public_path__ + "static/media/resume-link-icon.f1c9a53384d7301b72777b0504dc872a.svg";
export { ForwardRef as ReactComponent };